import { ViewPreset, DateHelper } from "@bryntum/schedulerpro";

// 日単位プリセット
const viewPresetDay = new ViewPreset({
  id: "day",
  name: "日単位",
  tickWidth: 42,
  tickHeight: 50,
  shiftUnit: "day",
  defaultSpan: 52,
  timeResolution: { unit: "day", increment: 1 },
  headers: [
    {
      unit: "month",
      dateFormat: date => `${date.getFullYear()}年${date.getMonth() + 1}月`,
    },
    {
      unit: "day",
      renderer: (start, end, headerConfig) => {
        const day = start.getDay();
        if (day === 0) headerConfig.headerCellCls = "calendar-sunday";
        if (day === 6) headerConfig.headerCellCls = "calendar-saturday";
        return DateHelper.format(start, "D日");
      },
    },
  ],
  columnLinesFor: 1,
});

// 週単位プリセット
const viewPresetWeek = new ViewPreset({
  id: "week",
  name: "週単位",
  tickWidth: 100,
  tickHeight: 50,
  shiftUnit: "week",
  defaultSpan: 52,
  timeResolution: { unit: "day", increment: 1 },
  headers: [
    {
      unit: "month",
      dateFormat: date => `${date.getFullYear()}年${date.getMonth() + 1}月`,
    },
    {
      unit: "week",
      renderer: date => `${date.getDate()}日`,
    },
  ],
  columnLinesFor: 1,
});

// 月単位プリセット
const viewPresetMonth = new ViewPreset({
  id: "month",
  name: "月単位",
  tickWidth: 100,
  tickHeight: 50,
  shiftUnit: "month",
  defaultSpan: 12,
  timeResolution: { unit: "month", increment: 1 },
  headers: [
    {
      unit: "year",
      dateFormat: date => `${date.getFullYear()}年`,
    },
    {
      unit: "month",
      dateFormat: date => `${date.getMonth() + 1}月`,
    },
  ],
  columnLinesFor: 1,
});

export const defaultPresets = [viewPresetDay, viewPresetWeek, viewPresetMonth];
